import { render, staticRenderFns } from "./ImportPortfolioStep3.vue?vue&type=template&id=b2f4eace&scoped=true&"
import script from "./ImportPortfolioStep3.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f4eace",
  null
  
)

export default component.exports